import React from 'react';
import discordLogo from "../../images/social/discord.png";
import facebookLogo from "../../images/social/facebook.png";
import youtubeLogo from "../../images/social/youtube.png";
import tiktokLogo from "../../images/social/tiktok.png";
import instagramLogo from "../../images/social/instagram.png";



const Socials = () => {

    return (
        <div className="me-auto socials">
            <a href="https://discord.gg/gF3Df2E" className="ms-2">
                <img className="social-icon" src={discordLogo} alt="discord"/>
            </a>
            <a href="https://www.facebook.com/DriftCornerGP/" className="ms-2">
                <img className="social-icon" src={facebookLogo} alt="facebook"/>
            </a>
            <a href="https://www.youtube.com/@DriftCornerGrandPrix" className="ms-2">
                <img className="social-icon" src={youtubeLogo} alt="youtube"/>
            </a>
            <a href="https://www.tiktok.com/@driftcornergp?lang=pl-PL" className="ms-2">
                <img className="social-icon" src={tiktokLogo} alt="tiktok"/>
            </a>
            <a href="https://www.instagram.com/driftcornergp/" className="ms-2">
                <img className="social-icon" src={instagramLogo} alt="instagram"/>
            </a>
        </div>
    );
}

export default Socials;
